import { BASE_API_URL } from "../../../config/url"

export const CREATE_SUBTOPIC_DONE = 'CREATE_SUBTOPIC_DONE'
export const UPDATE_SUBTOPIC_DONE = 'UPDATE_SUBTOPIC_DONE'
export const DELETE_SUBTOPIC_DONE = 'DELETE_SUBTOPIC_DONE'
export const GET_SUBTOPIC_DONE = 'GET_SUBTOPIC_DONE'

export const CREATE_SUBTOPIC_ERROR = 'CREATE_SUBTOPIC_ERROR'
export const UPDATE_SUBTOPIC_ERROR = 'UPDATE_SUBTOPIC_ERROR'
export const DELETE_SUBTOPIC_ERROR = 'DELETE_SUBTOPIC_ERROR'
export const GET_SUBTOPIC_ERROR = 'GET_SUBTOPIC_ERROR'

export const CREATE_SUBTOPIC_URL = `${BASE_API_URL}/group/subtopic/create`
export const UPDATE_SUBTOPIC_URL = `${BASE_API_URL}/group/subtopic/edit`
export const DELETE_SUBTOPIC_URL = `${BASE_API_URL}/group/subtopic`
export const GET_SUBTOPIC_URL = `${BASE_API_URL}/group/subtopic/group/all`
export const GET_SUBTOPIC_BY_TOPIC_URL = `${BASE_API_URL}/group/subtopic/all`
export const ORDER_SUBTOPIC_URL = `${BASE_API_URL}/group/subtopic/order`
